import { render, staticRenderFns } from "./PurchaseView.vue?vue&type=template&id=b634b50c"
import script from "./PurchaseView.vue?vue&type=script&lang=js"
export * from "./PurchaseView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports